module.exports = __webpack_public_path__ + "static/media/exampleformat.4eeda081.png";